export default {
  oauth: {
    path:
      process.env.REACT_APP_OAUTH_PATH ??
      'http://localhost:3001/api/auth/oauth',
  },
};
